import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import { academylist } from "../../../services/admin";
import { Col, Row } from "react-bootstrap";
import {
  studentdeletelogs,
  studentuploadbulk,
  studentuploadlogs,
} from "../../../services/student";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";

export default function Studentbulkupload() {
  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });



    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0]);

              }
            }

          }
        }
      });
    } else {
      listall("");
    }

  }, []);

  function listall(aid) {
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("type", 1);

    studentuploadlogs(temp).then((response) => {
      if (response.status === true) {
        setFilterProduct(response.data.details);
      }
    });
  }
  const [photoerror, setPhotoError] = useState("");
  const [pfile, setPFile] = useState("");

  function photofile(event) {
    setPhotoError("");
    setPFile("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(xls|xlsx)$/i)) {
        setPFile(event.target.files[0]);
      } else {
        setPhotoError("Upload Excel File should be xls or xlsx format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setPhotoError("Upload Excel File size should be less than 5MB");
      }
    }
  }

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e);
    } else {
      setAcaID("");
      listall("");
    }
  }

  const [trecord, setTRecord] = useState(0);
  const [irecord, setIRecord] = useState(0);
  const [urecord, setURecord] = useState(0);
  const [strecord, setStatus] = useState("");
  const [failid, setFailId] = useState(0);

  const [errorMessage, setErrorMessage] = useState("");
  function handleupload(e) {
    e.preventDefault();
    var valid = "";
    if (localStorage.getItem("Role") === "1" && acaid === "") {
      setErrorMessage("Please Select Academy");
      valid = "Please Select Academy";
    }
    if (valid === "") {
      if (pfile === "") {
        setErrorMessage("Upload Excel File");
      } else {
        setLoading(true);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1") {
          temp.append("academy_id", acaid.value);
        }
        temp.append("excel_name", pfile);
        studentuploadbulk(temp).then((response) => {
          if (response.status === true) {
            setLoading(false);
            if (localStorage.getItem("Role") === "1") {
              listall(acaid);
            } else {
              listall("");
            }
            toast.success(response.message);
            if (response.data.total_rows !== "") {
              setTRecord(response.data.total_rows);
            }
            if (response.data.inserted_count !== "") {
              setIRecord(response.data.inserted_count);
            }
            if (response.data.failed_count !== "") {
              setURecord(response.data.failed_count);
            }
            if (
              response.data.detail !== null &&
              response.data.detail.mandatory_excel !== null
            ) {
              setFailId(
                response.data.path + response.data.detail.mandatory_excel
              );
            }
            setStatus(response.data.status);
          } else {
            setLoading(false);
            toast.error(response.message);
          }
        });
      }
    }
  }

  const [filterProduct, setFilterProduct] = useState([]);
  const columnDefs = [

    {
      headerName: "Failed Excel",
      field: "mandatory_excel",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return (
            <div className="text-center">
              {/* <a
                className="btn-sm btn-danger me-2" onClick={() => handleDelete(params.data.id)}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a> */}

              <a
                className="excelfailed text-danger"
                href={params.data.path + params.value}
                download={params.data.path + params.value}
                target="_blank"
              >
                Click to Download
              </a>
            </div>
          );
        }
      },
    },
    {
      headerName: "Upload Excel",
      field: "excel_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              className="excelfailed text-success"
              href={params.data.path + params.value}
              download={params.data.path + params.value}
              target="_blank"
            >
              Click to Download
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Uploaded on",
      field: "created_at",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy hh:mm:ss A");
        }
      },
    },
    {
      headerName: "Uploaded by",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  function handleDelete(did) {
    Swal.fire({
      text: "Are you sure want to Delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const temp = new FormData();
        temp.append("excel_id", did);
        if (localStorage.getItem("Role") === "1") {
          temp.append("academy_id", acaid.value);
        }

        studentdeletelogs(temp).then((response) => {
          if (response.status === true) {
            listall(acaid);
          }
        });
      }
    });
  }
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div className="page-header">
        <>
          <h2 className="main-content-title tx-24 mg-b-5">
            Student Bulk Upload
          </h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Students</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Student Bulk Upload
            </li>
          </ol>
        </>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <Row className="row-sm mx-0">
                  {localStorage.getItem("Role") === "1" && (
                    <Col lg={6} md={6}>
                      <div className="mb-3">
                        <label className="form-label">
                          Select Academy <span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Academy"
                          value={acaid}
                          options={aclist}
                          onChange={handleAcademy}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                      </div>
                    </Col>
                  )}


                  <Col lg={6} md={6}>
                    <div className="mb-3">
                      <label className="form-label">
                        Upload Excel File{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="file"
                        id="file"
                        accept=".xlsx, .xls"
                        onChange={photofile}
                      />
                    </div>
                    {photoerror !== "" && (
                      <span className="text-danger">{photoerror}</span>
                    )}
                  </Col>

                  {errorMessage !== "" && (
                    <span className="text-danger">{errorMessage}</span>
                  )}
                </Row>

                <div className="text-end">
                  <a className="btn btn-secondary me-2" href={require("../../../assets/images/Student_BulkUpload.xlsx")} download>Download Sample Excel</a>
                  <a
                    onClick={handleupload}
                    className="btn btn-next btn-success"
                    style={{ float: "right" }}
                  >
                    Submit
                  </a>
                </div>
              </div>
            </div>
            <div className="row row-cards mt-1">
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                <div className="card bg-custom">
                  <div className="card-body text-center feature">
                    <p className="card-text mt-2">
                      <strong>Total Records</strong>
                    </p>
                    <p className="h3 text-center text-info">{trecord}</p>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                <div className="card bg-custom">
                  <div className="card-body text-center feature">
                    <p className="card-text mt-2">
                      <strong>Inserted Records</strong>
                    </p>
                    <p className="h3 text-center text-success">{irecord}</p>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                <div className="card bg-custom">
                  <div className="card-body text-center feature">
                    <p className="card-text mt-2">
                      <strong>Failed Records</strong>
                    </p>
                    <p className="h3 text-center text-danger">{urecord}</p>
                    {/* {urecord !== 0 && (
                    <a
                      className="excelfailed text-danger"
                      onClick={() => {
                        window.open(failid, "_blank");
                      }}
                    >
                      <b>Click to Download</b>
                    </a>
                  )} */}
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                <div className="card bg-custom">
                  <div className="card-body text-center feature">
                    <p className="card-text mt-2 mb-3">
                      <strong>Upload Status</strong>
                    </p>
                    {strecord === "Success" && (
                      <p className="badge badge-success">
                        <b>{strecord}</b>
                      </p>
                    )}
                    {strecord !== "Success" && (
                      <p className="badge badge-danger">
                        <b>{strecord}</b>
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
